/**
 * Tray text block for #bottom-rows-container — same inject pattern as TrayChoice.
 */

const OUTER_RADIUS_PX = 12;

export type TrayTextContent = {
  title: string;
  text: string;
};

export default class TrayText {
  primaryColor: string;
  title = '';
  body = '';
  root: HTMLElement | null = null;
  titleElement: HTMLElement | null = null;
  bodyElement: HTMLElement | null = null;

  constructor(primaryColor = '#da131c') {
    this.primaryColor = primaryColor;
    document.documentElement.style.setProperty('--primary-color', this.primaryColor);
    this.injectCSS();
    this.injectHTML();
    this.cacheDOM();
    this.applyContent();
  }

  injectCSS() {
    const styleId = 'tray-text-style';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .tray-text {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        z-index: 100;
        pointer-events: auto;
        display: none;
      }
      .tray-text-panel {
        width: 100%;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: ${OUTER_RADIUS_PX}px;
        padding: 12px 16px;
        box-shadow: var(--spotar-ui-box-shadow);
      }
      .tray-text-title {
        margin: 0 0 6px 0;
        font-size: 15px;
        font-weight: 700;
        color: #18181b;
        line-height: 1.3;
      }
      .tray-text-body {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        color: #3f3f46;
        line-height: 1.45;
        white-space: pre-wrap;
      }
    `;
    document.head.appendChild(style);
  }

  injectHTML() {
    const existing = document.getElementById('tray-text-root');
    if (existing) {
      this.root = existing;
      return;
    }

    const root = document.createElement('div');
    root.id = 'tray-text-root';
    root.className = 'tray-text';

    const panel = document.createElement('div');
    panel.className = 'tray-text-panel';

    const title = document.createElement('p');
    title.className = 'tray-text-title';

    const body = document.createElement('p');
    body.className = 'tray-text-body';

    panel.appendChild(title);
    panel.appendChild(body);
    root.appendChild(panel);
    document.getElementById('bottom-rows-container')!.appendChild(root);
    this.root = root;
  }

  cacheDOM() {
    if (!this.root) return;
    this.titleElement = this.root.querySelector('.tray-text-title');
    this.bodyElement = this.root.querySelector('.tray-text-body');
  }

  setContent(content: TrayTextContent) {
    this.title = content.title;
    this.body = content.text;
    this.applyContent();
  }

  applyContent() {
    if (this.titleElement) this.titleElement.textContent = this.title;
    if (this.bodyElement) this.bodyElement.textContent = this.body;
  }

  show() {
    if (!this.root) return;
    this.root.style.display = 'block';
  }

  hide() {
    if (!this.root) return;
    this.root.style.display = 'none';
  }
}
